<template>
	<div class="payment-item" :class="{'bottom-dashed-line': !last}" @click="toEdit">
		<ul class="info-cont">
			<li v-if="!is_trans"><span class="label">付款方式</span><span>{{ payment.vendor_title }}</span></li>
			<li v-if="is_trans">
				<span class="label">付款方式</span><span>转账</span>
				<a class="payment-edit yellow" v-show="allowEdit">修改</a>
			</li>
			<li><span class="label">付款金额</span><span>{{ payment.amount }}元</span></li>
			<li><span class="label">付款日期</span><span>{{ paid_time }}</span></li>
			<li><span class="label">付款状态</span><span class="yellow">{{ payment.pay_status_title }}</span></li>
			<li v-if="is_trans"><span class="label">转入账户</span><span>{{ payment.payment_way }}</span></li>
			<li v-if="is_trans && payment.bank_name"><span class="label">付款银行</span><span>{{ payment.bank_name }}</span></li>
			<li v-if="is_trans && payment.bank_account_name"><span class="label">付款账户</span><span>{{ payment.bank_account_name }}</span></li>
			<li v-if="has_trade_no"><span class="label">付款单号</span><span>{{ payment.trade_no }}</span></li>
			<li v-if="has_alipayid"><span class="label">付款账号</span><span>{{ payment.alipay_id }}</span></li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'OrderPayItem',
	props: ['payment', 'role', 'last'],
	data: () => ({
	}),
	mounted: function () {
	},
	computed: {
		is_online () {
			return this.payment.is_online
		},
		is_trans () {
			return this.payment.is_trans
		},
		allowEdit () {
			return this.payment.is_trans && this.payment.is_edit
		},
		has_trade_no () {
			return this.payment.trade_no
		},
		has_alipayid () {
			return this.payment.is_trans && this.payment.alipay_id
		},
		paid_time () {
			return this.payment.paid_time.substring(0, 10)
		}
	},
	methods: {
		toEdit () {
			if (this.payment.is_trans) {
				if (this.payment.is_edit) {
					this.$store.dispatch('setPayment', {'payment': this.payment})
					this.$router.push('/trans/edit')
				}
			}
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OrderPayItem.vue